import script from "./FAQs.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQs.vue?vue&type=script&setup=true&lang=ts"

import "./FAQs.vue?vue&type=style&index=0&id=3f79fa1a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f79fa1a"]])

export default __exports__